// Rótulo/resumo do "como pagar" — mesmas tabelas do PainelParcelaPagar. A forma e os
// dados bancários não moram em financeiroparcela: vêm da parcela do Efetivo, anexadas
// pelo backend em efetivo_forma / efetivo_dados_pagamento. Compartilhado pelas telas de detalhe
// (DetalheParcelaPagar e DetalhePrevisaoPagamento, D-0097).
const LABEL_FORMA_PGTO = {
    pix: 'PIX', cartao_credito: 'Crédito', cartao_debito: 'Débito', credito: 'Crédito',
    remessa: 'Remessa / TED', transferencia: 'Transferência', link: 'Link', boleto: 'Boleto', fatura: 'Fatura',
    cartao_fisico: 'Cartão físico', // D-0116
    apolice: 'Apólice', // D-0128
};
export function labelFormaPgto(f) { return LABEL_FORMA_PGTO[f] || f || ''; }

export function listaDadosPagamento(dados) {
    if (!dados || typeof dados !== 'object') return [];
    const p = [];
    if (dados.chave)           p.push(['Chave PIX', dados.chave + (dados.tipo_chave ? ' (' + dados.tipo_chave + ')' : '')]);
    if (dados.beneficiario)    p.push(['Beneficiário', dados.beneficiario]);
    if (dados.favorecido)      p.push(['Favorecido', dados.favorecido]);
    if (dados.banco)           p.push(['Banco', dados.banco]);
    if (dados.agencia)         p.push(['Agência', dados.agencia]);
    if (dados.conta)           p.push(['Conta', dados.conta]);
    if (dados.cpf_cnpj)        p.push(['CPF/CNPJ', dados.cpf_cnpj]);
    if (dados.linha_digitavel) p.push(['Linha digitável', dados.linha_digitavel]);
    if (dados.ultimos4)        p.push(['Cartão', '•••• ' + dados.ultimos4 + (dados.bandeira ? ' ' + dados.bandeira : '')]);
    if (dados.titular)         p.push(['Titular', dados.titular]);
    if (dados.link_pagamento)  p.push(['Link', dados.link_pagamento]);
    if (dados.url)             p.push(['Link', dados.url]);
    // Fatura: número e vencimento eram preenchidos no Efetivo e não apareciam aqui —
    // a conta chegava como "Fatura" e nada mais, sem dizer QUAL fatura pagar.
    if (dados.numero)          p.push(['Número da fatura', dados.numero]);
    if (dados.vencimento)      p.push(['Vencimento da fatura', formatarDataFatura(dados.vencimento)]);
    if (dados.descricao)       p.push(['Descrição', dados.descricao]);
    // D-0116: cartão físico — valor real da compra informado no Efetivo
    if (dados.valor_real)      p.push(['Valor real da compra', 'R$ ' + Number(dados.valor_real).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })]);
    return p;
}

// Vem do <input type="date"> do Efetivo, em AAAA-MM-DD.
function formatarDataFatura(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
    return m ? (m[3] + '/' + m[2] + '/' + m[1]) : String(v);
}

// A linha digitável é o dado que vai colado no internet banking — copiar na mão,
// selecionando 47 dígitos com o mouse, é onde nasce erro de pagamento.
